import apiServices from '../../../services/apiService';

export const amenityCommonApi = {

  // ── AMENITY TYPES (response data in res.data.data2) ───────────────
  getAllAmenityTypes: () =>
    apiServices({ url: '/Common/Amenities/GetAllAmenityTypes', method: 'GET' }),

  getAmenityTypeById: (id) =>
    apiServices({ url: `/Common/Amenities/GetAmenityTypeByTypeId/${id}`, method: 'GET' }),

  createAmenityType: (data) =>
    apiServices({ url: '/Common/Amenities/PostAmenityType', method: 'POST', data }),

  updateAmenityType: (id, data) =>
    apiServices({ url: `/Common/Amenities/UpdateAmenityType/${id}`, method: 'PUT', data }),

  // ── AMENITIES MASTER (response data in res.data.data) ─────────────
  getAllAmenities: () =>
    apiServices({ url: '/Common/Amenities/GetAllAmenities', method: 'GET' }),

  getAmenityById: (id) =>
    apiServices({ url: `/Common/Amenities/GetAmenityById/${id}`, method: 'GET' }),

  getAmenitiesByType: (typeId) =>
    apiServices({ url: `/Common/Amenities/GetAmenityByAmenityId/${typeId}`, method: 'GET' }),

  createAmenity: (data) =>
    apiServices({ url: '/Common/Amenities/PostAmenity', method: 'POST', data }),

  updateAmenity: (id, data) =>
    apiServices({ url: `/Common/Amenities/PutAmenity/${id}`, method: 'PUT', data }),

  deleteAmenity: (id) =>
    apiServices({ url: `/Common/Amenities/DeleteAmenity/${id}`, method: 'DELETE' }),

  // ── BOOKINGS ──────────────────────────────────────────────────────
  getUsers: (isCommercial) => {
      const url = isCommercial
          ? `/CommUserDetails/getUserDetails?PageNumber=1&PageSize=100`
          : `/Residential/ResUserDetails/getUserDetails?PageNumber=1&PageSize=100`;
      return apiServices({ url, method: 'GET' });
  },

  getBookings: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.siteId)           params.append('siteId', filters.siteId);
    if (filters.unitId)           params.append('unitId', filters.unitId);
    if (filters.personId)         params.append('personId', filters.personId);
    if (filters.amenityBookingId) params.append('amenityBookingId', filters.amenityBookingId);
    return apiServices({ url: `/Common/AmenitiesBooking/GetResAmenitiesBooking?${params}`, method: 'GET' });
  },

  createBooking: (data) =>
    apiServices({ url: '/Common/AmenitiesBooking/CreateAmenityBookingAsync', method: 'POST', data }),

  updateBooking: (id, data) =>
    apiServices({ url: `/Common/AmenitiesBooking/UpdateAmenityBookingAsync/${id}`, method: 'PUT', data }),

  cancelBooking: (id) =>
    apiServices({ url: `/Common/AmenitiesBooking/cancelAmenityBooking/${id}`, method: 'PUT' }),

  approveOrRejectBooking: (bookingId, bookingStatus) =>
    apiServices({
      url: `/Common/AmenitiesBooking/approveORrejectAmenityBooking/${bookingId}`,
      method: 'PUT',
      data: { bookingId, bookingStatus }
    }),

  updatePayment: (data) =>
    apiServices({ url: '/Common/AmenitiesBooking/updateBookingPayment', method: 'PUT', data }),

  // ── REPORTS ───────────────────────────────────────────────────────
  getBookingReport: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.siteId)        params.append('siteId', filters.siteId);
    if (filters.unitId)        params.append('unitId', filters.unitId);
    if (filters.personId)      params.append('personId', filters.personId);
    if (filters.fromDate)      params.append('fromDate', filters.fromDate);
    if (filters.toDate)        params.append('toDate', filters.toDate);
    if (filters.bookingStatus) params.append('bookingStatus', filters.bookingStatus);
    return apiServices({ url: `/Common/AmenitiesBooking/getBookingReport?${params}`, method: 'GET' });
  },
};
